// フォントの読み込みを監視する関数
function waitForFonts() {
  return new Promise((resolve) => {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        // 追加の待機時間を設定（必要に応じて調整）
        setTimeout(resolve, 100);
      });
    } else {
      // document.fonts.ready がサポートされていない場合のフォールバック
      setTimeout(resolve, 1000);
    }
  });
}

// グローバルに公開
window.waitForFonts = waitForFonts;
